import React from "react";
import Navbar from "../../../navbar";
import Footer from "../../../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../../../seo";

import { Link } from "gatsby";

import blogData from "../../../bloginner/data";

// import banner from "../../../../images/memoryfoamvslatexfoam.png";

export default function OptimiseYourSleep(props) {
  const { location, data } = props;

  //   const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i className="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i className="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog optimiseyoursleep">
      <SEO
        title={
          "Optimize Your Sleep environment | Eclipse International"
        }
        description={""}
        img={""}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">
          Optimize Your Sleep Environment
        </h1>
        <div className="blog__header">
          <div className="blog__header__date">August 22, 2022</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg blog__headerimg--desktop"
          src={
            "https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner.jpg"
          }
          alt="Blog Header Image"
        ></img>
        <img
          className="blog__headerimg blog__headerimg--mobile"
          src={
            "https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <div className="blog__container">
          <p>
            <p>
              The ideal ambience can enable high quality rest and good sleep health.
              <br />
              <br />
              Sleep environment is an underrated aspect of sleep hygiene. Change up your room to relax better and quickly transition to rest with these tips.

              <br /> <br />
              Remember, the ideal sleep conditions are cool, quiet and dark.
            </p>
          </p>
          <div className="row">
            <div className="col col-6 col-lg-6 col-xl-4">
              <div className="optimiseyoursleep__card">
                <img src="https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner-icons-1.png" />
                <div>
                  <h4>Cool Yet Comfortable Temperature</h4>
                </div>
              </div>
            </div>
            <div className="col col-6 col-lg-6 col-xl-4">
              <div className="optimiseyoursleep__card">
                <img src="https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner-icons-2.png" />
                <div>
                  <h4>Block out light</h4>
                </div>
              </div>
            </div>
            <div className="col col-6 col-lg-6 col-xl-4">
              <div className="optimiseyoursleep__card">
                <img src="https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner-icons-3.png" />
                <div>
                  <h4>Drown out noise</h4>
                </div>
              </div>
            </div>
            <div className="col col-6 col-lg-6 col-xl-4">
              <div className="optimiseyoursleep__card">
                <img src="https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner-icons-4.png" />
                <div>
                  <h4>Trying calming aromatherapy</h4>
                </div>
              </div>
            </div>
            <div className="col col-6 col-lg-6 col-xl-4">
              <div className="optimiseyoursleep__card">
                <img src="https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner-icons-5.png" />
                <div>
                  <h4>Choose the best mattress</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
